import { paymentTermListResponseSchema, type PaymentTermListResponse } from '@erp/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch, type ApiError } from '@/lib/api-client';

export const paymentTermKeys = {
  sales: ['payment-terms', 'sales'] as const,
};

export function useSalesPaymentTerms(): UseQueryResult<PaymentTermListResponse, ApiError> {
  return useQuery({
    queryKey: paymentTermKeys.sales,
    queryFn: () => apiFetch('/api/v1/partners/payment-terms', paymentTermListResponseSchema),
    staleTime: 5 * 60 * 1000,
  });
}
